import PasswordInput from './PasswordInput';

// export types
export type { PasswordInputProps } from './PasswordInput';

// export components
export { PasswordInput };
export default PasswordInput;
